import { isMasked } from '../misc/sanitizers';

const UOM_ABBREV_MAP = {
  Hectare: 'HEC',
  Acre: 'ACR',
  'Square KM': 'SQ KM',
  SquareKilometer: 'SQ KM',
  'Square Mile': 'SQ MI',
  SquareMile: 'SQ MI',
  'Square Meter': 'sqm',
  SquareMeter: 'sqm',
  // Square foot
  'Square Foot': 'SF',
  'Square Feet': 'SF',
  SquareFeet: 'SF',
  'US Dollar': 'USD',
  'Danish Krone': 'DKK',
  'Great Britain Pound': 'GBP',
  'Swiss Franc': 'CHF',
  Unknown: '-',
  null: '-',
  undefined: '-',
  Euro: 'EUR',
  'Norwegian Krone': 'NOK',
  'Russian Ruble': 'RUB',
  'Swedish Krona': 'SEK',
};
const UOM_ABBREV_MAP_INIT = {
  Hectare: 'HEC',
  Acre: 'ACR',
  'Square KM': 'SQ KM',
  SquareKilometer: 'SQ KM',
  'Square Mile': 'SQ MI',
  SquareMile: 'SQ MI',
  'Square Meter': 'SQM',
  SquareMeter: 'SQM',
  // Square foot
  'Square Foot': 'SqFt',
  'Square Feet': 'SqFt',
  SquareFeet: 'SqFt',
  'US Dollar': 'USD',
  Unknown: '-',
  null: '-',
  undefined: '-',
};
const UOM_ABBREV_MAP_COUNTRY = {
  'United Kingdom': {
    Hectare: 'HEC',
    Acre: 'ACR',
    'Square KM': 'SQ KM',
    SquareKilometer: 'SQ KM',
    'Square Mile': 'SQ MI',
    SquareMile: 'SQ MI',
    'Square Meter': 'sqm',
    SquareMeter: 'sqm',
    // Square foot
    'Square Foot': 'sq ft',
    'Square Feet': 'sq ft',
    SquareFeet: 'sq ft',
    'US Dollar': 'USD',
    Unknown: '-',
    null: '-',
    undefined: '-',
  },
  EMEA: {
    Hectare: 'HEC',
    Acre: 'ACR',
    'Square KM': 'SQ KM',
    SquareKilometer: 'SQ KM',
    'Square Mile': 'SQ MI',
    SquareMile: 'SQ MI',
    'Square Meter': 'sqm',
    SquareMeter: 'sqm',
    'Square Foot': 'sq ft',
    'Square Feet': 'sq ft',
    Unknown: '-',
    null: '-',
    undefined: '-',
  },
};

export const areaUomAbbrev = val => {
  if (isMasked(val)) {
    return val;
  }
  const abbrev = UOM_ABBREV_MAP[val];
  return abbrev ? abbrev : val;
};
export const areaUomAbbrevForStackingPlan = val => {
  if (isMasked(val)) {
    return val;
  }
  const abbrev = UOM_ABBREV_MAP_INIT[val];
  return abbrev ? abbrev : val;
};
export const areaUomAbbrevCountry = (val, country) => {
  if (isMasked(val)) {
    return val;
  }
  if (UOM_ABBREV_MAP_COUNTRY[country]) {
    const countryObj = UOM_ABBREV_MAP_COUNTRY[country];
    return countryObj[val] ? countryObj[val] : val;
  } else {
    return areaUomAbbrev(val);
  }
};
